export default __webpack_public_path__ + "static/char-v-42-912d587d9af43472d13ae01848185073.png";